<template>
    <div class="schedule-detail__result">
        <div class="bus-section" v-for="(bus, busId) in busList" :key="busId">
            <div class="bus-section__title">
                <strong>{{ bus.name }}</strong>
                {{ bus.brand }} {{ bus.licensePlate }}
            </div>
            <div class="bus-section__content">
                <div class="bus-section__content__pickup" v-if="bus.pickupRouteInfo">
                    <table>
                        <tr>
                            <th>
                                {{ $t('common.pickup_route') }}
                                <template v-if="bus.pickupRouteInfo.subDriverName">
                                    - <span class="sub-driver-name">{{ bus.pickupRouteInfo.subDriverName }}</span>
                                </template>
                            </th>
                            <template v-for="(placeName, id) in bus.pickupRouteInfo.name">
                                <th v-if="bus.pickupRouteInfo.availablePlaceList.indexOf(id) !== -1" :key="id">
                                    {{ placeName }}
                                </th>
                            </template>
                        </tr>
                        <tr>
                            <td>{{ $t('common.number_of_students') }}</td>
                            <template v-for="(quantity, id) in bus.pickupRouteInfo.quantity">
                                <td v-if="bus.pickupRouteInfo.availablePlaceList.indexOf(id) !== -1" :key="id">
                                    {{ quantity }}
                                </td>
                            </template>
                        </tr>
                        <tr>
                            <td>{{ $t('common.departure_time')}}</td>
                            <template v-for="(time, id) in bus.pickupRouteInfo.time">
                                <td v-if="bus.pickupRouteInfo.availablePlaceList.indexOf(id) !== -1" :key="id">
                                    {{ time }}
                                </td>
                            </template>
                        </tr>
                    </table>
                </div>
                <div class="bus-section__content__drop" v-if="bus.dropRouteInfo">
                    <div v-for="(dropRoute, dropRouteId) in bus.dropRouteInfo" :key="dropRouteId">
                        <table v-for="(dropRouteData, timeKey) in dropRoute.times" :key="`${dropRouteId}_${timeKey}`">
                            <tr>
                                <th>
                                    {{ $t('common.drop_route') }}
                                    - <span :style="{color: dropRoute.routeColor}">{{ dropRoute.routeName }}</span>
                                    <template v-if="dropRoute.subDriverName">
                                        - <span class="sub-driver-name">{{ dropRoute.subDriverName }}</span>
                                    </template>
                                </th>
                                <template v-for="(placeName, id) in dropRouteData.name">
                                    <th v-if="dropRouteData.availablePlaceList.indexOf(id) !== -1" :key="id">
                                        {{ placeName }}
                                    </th>
                                </template>
                            </tr>
                            <tr>
                                <td>{{ $t('common.number_of_students') }}</td>
                                <template v-for="(quantity, id) in dropRouteData.quantity">
                                    <td v-if="dropRouteData.availablePlaceList.indexOf(id) !== -1" :key="id">
                                        {{ quantity }}
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <td>{{ $t('common.departure_time') }}</td>
                                <template v-for="(time, id) in dropRouteData.time">
                                    <td v-if="dropRouteData.availablePlaceList.indexOf(id) !== -1" :key="id">
                                        {{ time }}
                                    </td>
                                </template>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'ScheduleResult',
    props: ['pickupStudentList', 'dropStudentList', 'masterData', 'date'],
    components: {

    },
    data: function () {
      return {
        availablePlaceIds: {
          pickup: {},
          drop: {}
        },
        busMasterList: {},
        subDriverMasterList: {},
        pickupRouteMasterList: {},
        dropRouteMasterList: {}
      }
    },
    created: function () {
      this.setMasterData()
    },
    methods: {
      getPlaceIdByKey (placeKey) {
        return placeKey.replace('place_', '')
      },
      setMasterData: function () {
        this.masterData.bus_list.forEach((busItem) => {
          this.busMasterList[busItem.id] = Object.assign({}, busItem)
        })

        this.masterData.sub_driver_list.forEach((subDriverItem) => {
          this.subDriverMasterList[subDriverItem.id] = Object.assign({}, subDriverItem)
        })

        this.masterData.pickup_route_list.forEach((pickupRouteItem) => {
          this.pickupRouteMasterList[pickupRouteItem.id] = Object.assign({}, pickupRouteItem)
        })

        this.masterData.drop_route_list.forEach((dropRouteItem) => {
          this.dropRouteMasterList[dropRouteItem.id] = Object.assign({}, dropRouteItem)
        })
      },
      calculatePickupRoute(busList) {
        this.pickupStudentList.forEach((studentItem) => {
          if (studentItem.bus_id
            && this.busMasterList[studentItem.bus_id]
            && studentItem.pickup_route_info
            && this.pickupRouteMasterList[studentItem.pickup_route_info.id]) {
            let bus = this.busMasterList[studentItem.bus_id]
            let subDriver = this.subDriverMasterList[studentItem.sub_driver_id] || null
            let pickupRoute = this.pickupRouteMasterList[studentItem.pickup_route_info.id]
            let pickupRouteInfo

            if (pickupRoute.place_list.length) {
              if (typeof busList[studentItem.bus_id] === 'undefined') {
                busList[studentItem.bus_id] = {
                  id: studentItem.bus_id,
                  name: bus.name,
                  brand: bus.brand,
                  licensePlate: bus.license_plate,
                  pickupRouteInfo: {
                    name: {},
                    time: {},
                    quantity: {},
                    availablePlaceList: [],
                    subDriverName: subDriver ? subDriver.name : null
                  },
                  dropRouteInfo: {}
                }

                pickupRouteInfo = busList[studentItem.bus_id].pickupRouteInfo

                pickupRoute.place_list.forEach((placeItem, index) => {
                  let placeKey = `place_${placeItem.id}`
                  pickupRouteInfo.name[placeKey] = placeItem.name
                  pickupRouteInfo.time[placeKey] = placeItem.pickup_time
                  pickupRouteInfo.quantity[placeKey] = 0

                  if (!index || index === pickupRoute.place_list.length - 1) {
                    pickupRouteInfo.availablePlaceList.push(placeKey)
                  }
                })
              } else {
                pickupRouteInfo = busList[studentItem.bus_id].pickupRouteInfo
              }

              let placeKey = `place_${studentItem.place_info.id}`
              let schoolKey = `place_${pickupRoute.place_list[pickupRoute.place_list.length - 1].id}`
              pickupRouteInfo.quantity[placeKey]++
              pickupRouteInfo.quantity[schoolKey]++

              if (pickupRouteInfo.availablePlaceList.indexOf(placeKey) === -1) {
                pickupRouteInfo.availablePlaceList.push(placeKey)
              }
            }
          }
        })
      },
      calculateDropRoute (busList) {
        let currentDate = this.$moment().format('YYYY-MM-DD')

        this.dropStudentList.forEach((studentItem) => {
          if (studentItem.bus_id
            && this.busMasterList[studentItem.bus_id]
            && studentItem.drop_route_info
            && this.dropRouteMasterList[studentItem.drop_route_info.id]) {
            let bus = this.busMasterList[studentItem.bus_id]
            let subDriver = this.subDriverMasterList[studentItem.sub_driver_id] || null
            let dropRoute = this.dropRouteMasterList[studentItem.drop_route_info.id]
            let dropRouteInfo

            if (dropRoute.place_list.length) {
              if (typeof busList[studentItem.bus_id] === 'undefined') {
                busList[studentItem.bus_id] = {
                  id: studentItem.bus_id,
                  name: bus.name,
                  brand: bus.brand,
                  licensePlate: bus.license_plate,
                  pickupRouteInfo: null,
                  dropRouteInfo: {}
                }
              }

              if (typeof busList[studentItem.bus_id].dropRouteInfo[dropRoute.id] === 'undefined') {
                busList[studentItem.bus_id].dropRouteInfo[dropRoute.id] = {
                  times: {},
                  subDriverName: subDriver ? subDriver.name : null,
                  routeName: dropRoute.name,
                  routeColor: dropRoute.color
                }

                dropRouteInfo = busList[studentItem.bus_id].dropRouteInfo[dropRoute.id]
              } else {
                dropRouteInfo = busList[studentItem.bus_id].dropRouteInfo[dropRoute.id]
              }

              let timeData

              if (typeof dropRouteInfo['times'][studentItem.time] === 'undefined') {
                timeData = {
                  name: {},
                  quantity: {},
                  time: {},
                  availablePlaceList: []
                }

                let durationTotal = 0

                dropRoute.place_list.forEach((placeItem, index) => {
                  let placeKey = `place_${placeItem.id}`
                  let time
                  timeData.name[placeKey] = placeItem.name
                  timeData.quantity[placeKey] = 0

                  if (!index || index === dropRoute.place_list.length - 1) {
                    timeData.availablePlaceList.push(placeKey)
                  }

                  if (!index) {
                    time = studentItem.time
                  } else {
                    durationTotal += placeItem.duration
                    time = this.$moment(`${currentDate} ${studentItem.time}`).add(durationTotal, 'minutes').format('H:mm')
                  }

                  timeData.time[placeKey] = time
                })

                dropRouteInfo['times'][studentItem.time] = timeData
              } else {
                timeData = dropRouteInfo['times'][studentItem.time]
              }

              let placeKey = `place_${studentItem.place_info.id}`
              let schoolKey = `place_${dropRoute.place_list[0].id}`
              timeData.quantity[placeKey]++
              timeData.quantity[schoolKey]++

              if (timeData.availablePlaceList.indexOf(placeKey) === -1) {
                timeData.availablePlaceList.push(placeKey)
              }
            }
          }
        })
      }
    },
    computed: {
      ...mapState('schedule', ['dropRouteTimes']),
      busList: function () {
        let busList = {}
        this.calculatePickupRoute(busList)
        this.calculateDropRoute(busList)

        return busList
      },
      isEditable: function () {
        let currentDate = this.$moment().format('YYYY-MM-DD')

        return this.date >= currentDate
      }
    }
  }
</script>
<style lang="scss">
    .schedule-detail__result {
        text-align: left;

        .bus-section {
            margin-bottom: 50px;

            &__title {
                margin-bottom: 10px;
            }

            table {
                margin-bottom: 10px;
            }
        }

        .sub-driver-name {
            color: #000;
        }
    }


</style>